import {
  Button,
  ButtonGroup,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import { t } from '@transifex/native';
import { useDrawerStateDispatch } from 'features/main/context';
import { closeDrawer } from 'features/main/context/drawer/actionCreators';
import { pdfjs, Document, Page } from 'react-pdf';
import { useEndOfText } from '../hooks/useEndOfText';
import { getPdfWorkerSrc } from './pdfWorkerSrc';
import { ForwardedModalBody, constructStreamPayload } from '../utils/utils';
import '../assets/AnnotationLayer.css';
import '../assets/TextLayer.css';
import {
  GetOrderActivationsDocument,
  useOrderActivationStreamMutation,
} from 'gql/graphql';

pdfjs.GlobalWorkerOptions.workerSrc = getPdfWorkerSrc();

export const StreamTermsModal = ({
  isOpen,
  onCloseHandler,
  region,
}: {
  isOpen: boolean;
  onCloseHandler: (value: boolean) => void;
  region?: string;
}) => {
  const toast = useToast();
  const [, drawerDispatch] = useDrawerStateDispatch();

  const [orderActivationStreamMutation, { loading }] =
    useOrderActivationStreamMutation();

  const { isEndOfText, setIsEndOfText, node } = useEndOfText();

  const modalCloseDrawer = () => {
    setIsEndOfText(false);
    onCloseHandler(false);
  };

  const handleSubmit = async () => {
    const variables = constructStreamPayload({
      region,
    });

    try {
      const { data } = await orderActivationStreamMutation({
        //@ts-expect-error
        variables,
        refetchQueries: [GetOrderActivationsDocument],
      });

      const error = data?.orderActivation.errors?.[0];
      if (error) {
        return toast({
          description: error?.message,
          title: 'Error',
          status: 'error',
        });
      }
      drawerDispatch(closeDrawer());
      onCloseHandler(false);

      toast({
        title: t(
          'You will be notified regarding the process of the provisioning.',
        ),
        status: 'success',
      });
    } catch (error: any) {
      const { networkError } = error ?? {};
      toast({
        description: networkError.message,
        title: `Error ${networkError.statusCode}`,
        status: 'error',
      });
    }
  };

  return (
    <Modal
      onClose={modalCloseDrawer}
      isOpen={isOpen}
      size='4xl'
      scrollBehavior='inside'
      blockScrollOnMount={false}
    >
      <ModalOverlay />
      <ModalContent aria-label='trial consent'>
        <ModalHeader>Sitecore Stream Terms and Conditions</ModalHeader>
        <ModalCloseButton />
        <ForwardedModalBody aria-label='consent body' ref={node}>
          <Document
            externalLinkTarget='_blank'
            file='/portal-ui/Stream Trial EULA.pdf'
          >
            <Page pageNumber={1} />
            <br />
            <Page pageNumber={2} />
            <br />
            <Page pageNumber={3} />
            <br />
            <Page pageNumber={4} />
            <br />
            <Page pageNumber={5} />
            <br />
            <Page pageNumber={6} />
            <br />
            <Page pageNumber={7} />
            <br />
          </Document>
        </ForwardedModalBody>
        <ModalFooter>
          <ButtonGroup>
            <Button
              data-testid='cancel-btn'
              type='button'
              variant='ghost'
              onClick={modalCloseDrawer}
              isDisabled={loading}
            >
              Cancel
            </Button>
            <Button
              variant='solid'
              onClick={handleSubmit}
              isDisabled={!isEndOfText}
              isLoading={loading}
              data-testid='stream-accept-enable'
              aria-label='accept and enable'
            >
              Accept and enable
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
